import { Role } from '../role';
import { RoleName } from '@enums/role-name.enum';
import { Client } from '@classes/client';

export class AuthUser {
  username: string;
  role: Role;

  constructor(username: string, role: Role) {
    this.username = username;
    this.role = role;
  }

  // public get isReadOnly(): boolean {
  //     return (
  //         this.role.name === RoleName.driver
  //         || this.role.name === RoleName.labo
  //     );
  // }
}
